import { Spin } from 'antd';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useLoading } from '../../../context/LoadingProvider/useLoading';
import pillotLogo from '../../../assets/pillot_loading.png'

const antIcon = <LoadingOutlined style={{ fontSize: 48, color: '#000' }} spin />

const Loading = () => {
    const isLoading = useLoading()

    return (
        <div className={`loading ${(isLoading.loading) && 'loading--active'}`}>
            <Spin indicator={antIcon} />
        </div>
    )
}

export default Loading;